import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Button, Grid, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

export default function ItemSummary({data}) {
  // ==========> Component States <==========
  const [showDetails, setShowDetails] = useState(false);

  //Dates
  const createdAt = new Date(data.createdAt);

  //Date formatting
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  
  // ==========> Component <==========
  return (
    <Grid container spacing={1} justifyContent="flex-start" textAlign="left">
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          <Typography variant="body2" fontWeight="bold">
            Nombre del ítem
          </Typography>
          <Typography variant="h6">{data.name}</Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          <Typography variant="body2" fontWeight="bold">
            Tipo de ítem
          </Typography>
          <Typography variant="body2">{data.category}</Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ fontSize: "10px" }}
          color="secondary"
          size="small"
          startIcon={!showDetails ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? "ver menos información" : "ver más información"}
        </Button>
      </Grid>
      {showDetails && (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Stack
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                <Typography variant="body2" fontWeight="bold">
                  Fecha de creación
                </Typography>
                <Typography variant="body2">
                  {createdAt.toLocaleDateString("es-ES", options)}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                <Typography variant="body2" fontWeight="bold">
                  Usuario generador
                </Typography>
                <Typography variant="body2">{data.createdBy}</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
